import { render, staticRenderFns } from "./EnrolleeFeedbacks.vue?vue&type=template&id=2d9b6202&scoped=true&"
import script from "./EnrolleeFeedbacks.vue?vue&type=script&lang=js&"
export * from "./EnrolleeFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./EnrolleeFeedbacks.vue?vue&type=style&index=0&id=2d9b6202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b6202",
  null
  
)

export default component.exports